<div class="contato-iniciativa-card-control-radio"
    [class.invalid]="!config.isValid">
    <ng-template [ngIf]="disabled">
        <input type="text" class="form-control" [value]="ngModel | contatoIniciativa | uppercase" disabled="disabled" readonly="readonly">
    </ng-template>
    
    <div class="card-control-radio-container" *ngIf="!disabled">
        <ng-template ngFor let-iniciativa [ngForOf]="iniciativasOptions">
            <div class="card card-control-radio" [class.active]="ngModel === iniciativa.id" (click)="onChange(iniciativa)">
                <div class="custom-control custom-radio">
                    <input type="radio" class="custom-control-input" [name]="name" id="{{id}}_{{iniciativa.id}}" [value]="iniciativa.id" [ngModel]="ngModel" (ngModelChange)="onChange($event)"
                        #contatoIniciativaModel="ngModel" #controlInput [required]="required">                     
                    <label class="custom-control-label" for="{{id}}_{{iniciativa.id}}">
                        <span class="custom-control-label-title">
                            <i class="{{iniciativa.id | contatoIniciativaIcon}}"></i> {{iniciativa.nome}}
                        </span>
                        <span class="custom-control-label-subtitle">
                            {{iniciativa.descricao}}
                        </span>
                    </label>
                </div> 
            </div>
        </ng-template> 
    </div>
</div>